import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Screen\LogoffScreenController::__invoke
* @see app/Http/Controllers/Screen/LogoffScreenController.php
* @route '/api/screen-settings/{screen}/logoff'
*/
const LogoffScreenController = (args: { screen: string | number | { id: string | number } } | [screen: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: LogoffScreenController.url(args, options),
    method: 'post',
})

LogoffScreenController.definition = {
    methods: ["post"],
    url: '/api/screen-settings/{screen}/logoff',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Screen\LogoffScreenController::__invoke
* @see app/Http/Controllers/Screen/LogoffScreenController.php
* @route '/api/screen-settings/{screen}/logoff'
*/
LogoffScreenController.url = (args: { screen: string | number | { id: string | number } } | [screen: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { screen: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { screen: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            screen: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        screen: typeof args.screen === 'object'
        ? args.screen.id
        : args.screen,
    }

    return LogoffScreenController.definition.url
            .replace('{screen}', parsedArgs.screen.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Screen\LogoffScreenController::__invoke
* @see app/Http/Controllers/Screen/LogoffScreenController.php
* @route '/api/screen-settings/{screen}/logoff'
*/
LogoffScreenController.post = (args: { screen: string | number | { id: string | number } } | [screen: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: LogoffScreenController.url(args, options),
    method: 'post',
})

export default LogoffScreenController